import Pubnub from 'pubnub';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../../..';
import { getErrorText } from '../helpers';

type Params = {
  channel: string;
  messageTimetoken: string;
  message: string;
};

type Response = { data: Pubnub.MessageAction };
// type Response = { data: Record<string, unknown> };

export const updateMessage = createAsyncThunk<Response, Params, { rejectValue: string }>(
  'pubnub/updateMessage',
  async (data, { rejectWithValue, getState }) => {
    try {
      const pubnubReducer = (getState() as RootState).pubnub;

      if (pubnubReducer.pubnub) {
        const result = await pubnubReducer.pubnub.addMessageAction({
          channel: data.channel,
          messageTimetoken: data.messageTimetoken,
          action: {
            type: 'updated',
            value: data.message,
          },
        });

        return result;
      } else {
        throw new Error('PubnubInstanceIsNull');
      }
    } catch (e) {
      return rejectWithValue(getErrorText(e as Error));
    }
  },
);
